import { forwardRef } from 'react';
import clsx from 'clsx';
// components
import { CircleX, Info, TriangleAlert } from 'lucide-react';
import { ILevel, ILogType } from '@newo/api/gateway';
import DateTime from '@/modules/DateTime/components/DateTime';
// icons
// utils
import { DATE_FORMAT } from '@/const';
// assets
import styles from '@/modules/Analytics/components/SystemOutput/components/LogItem/LogItem.module.css';

interface LogItemProps {
    className?: string;
    level: ILevel;
    type: ILogType;
    datetime: string;
    children: React.ReactNode;
}

const LogItem = forwardRef<HTMLDivElement, LogItemProps>(function LogItem(
    { className, level, type, datetime, children },
    ref
) {
    return (
        <div
            className={clsx(
                styles.log,
                {
                    [styles.warning]: level === 'warning',
                    [styles.error]: level === 'error'
                },
                styles[level],
                className
            )}
            ref={ref}
        >
            <div className="flex w-24 shrink-0 gap-2">
                {level === 'error' && <CircleX className={styles.levelIcon} />}
                {level === 'warning' && (
                    <TriangleAlert className={styles.levelIcon} />
                )}
                {level === 'info' && <Info className={styles.levelIcon} />}
                {type}
            </div>
            <div className={styles.content}>{children}</div>
            <DateTime format={DATE_FORMAT.FULL_12H_MS} value={datetime} />
        </div>
    );
});

export default LogItem;
